import { lazy } from "react";
import { Navigate } from "react-router-dom";

import AuthGuard from "./auth/AuthGuard";
import { authRoles } from "./auth/authRoles";

import Loadable from "./components/Loadable";
import MatxLayout from "./components/MatxLayout/MatxLayout";

import materialRoutes from "app/views/material-kit/MaterialRoutes";
import DealEdit from "./views/deals/DealEdit";
import { element } from "prop-types";

// SESSION PAGES
const NotFound = Loadable(lazy(() => import("app/views/sessions/NotFound")));
const JwtLogin = Loadable(lazy(() => import("app/views/sessions/JwtLogin")));
const JwtRegister = Loadable(
  lazy(() => import("app/views/sessions/JwtRegister"))
);
const ForgotPassword = Loadable(
  lazy(() => import("app/views/sessions/ForgotPassword"))
);
// E-CHART PAGE
const AppEchart = Loadable(
  lazy(() => import("app/views/charts/echarts/AppEchart"))
);
//AGENTS PAGE
const Agents = Loadable(lazy(() => import("app/views/agents/Agents")));

//MAP PAGE
const Map = Loadable(lazy(() => import("app/views/grafics/GraphicPage")));

// DASHBOARD PAGE
const Analytics = Loadable(lazy(() => import("app/views/dashboard/Analytics")));
// DEALS PAGE
const Deals = Loadable(lazy(() => import("app/views/deals/Deals")));
const DealShow = Loadable(lazy(() => import("app/views/deals/DealShow")));
const DealsEdit = Loadable(lazy(() => import("app/views/deals/DealEdit")));
const DealsCreate = Loadable(lazy(() => import("app/views/deals/DealCreate")));
// PARTNERS PAGES
const Partners = Loadable(lazy(() => import("app/views/partners/Partners")));
const Companies = Loadable(lazy(() => import("app/views/partners/Companies")));
const PartnerShow = Loadable(
  lazy(() => import("app/views/partners/PartnerShow"))
);
const PartnerEdit = Loadable(
  lazy(() => import("app/views/partners/PartnerEdit"))
);
// LEADS PAGES
const Leads = Loadable(lazy(() => import("app/views/leads/Leads")));
const LeadShow = Loadable(lazy(() => import("app/views/leads/LeadShow")));
const LeadEdit = Loadable(lazy(() => import("app/views/leads/LeadEdit")));
// USDA PAGES
const Usda = Loadable(lazy(() => import("app/views/pricing/Pricing")));
// TREASURY PAGES
const Treasury = Loadable(lazy(() => import("app/views/treasury/Treasury")));
const UncomingPayments = Loadable(
  lazy(() => import("app/views/treasury/UncomingPaymentsList"))
);
const TreasuryIndicators = Loadable(
  lazy(() => import("app/views/treasury/TreasuryIndicators"))
);
const PaymentAprovalForm = Loadable(
  lazy(() => import("app/views/treasury/PaymentAprovalForm"))
);

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...materialRoutes,
      //agents route
      { path: "/agents/:id?", element: <Agents />, auth: authRoles.admin },

      //map route
      { path: "/map", element: <Map />, auth: authRoles.admin },

      // dashboard route
      {
        path: "/dashboard/default",
        element: <Analytics />,
        auth: authRoles.admin,
      },
      // deals route
      { path: "/deals", element: <Deals />, auth: authRoles.admin },
      // deal show route
      { path: "/deals/:id", element: <DealShow />, auth: authRoles.admin },
      // deal edit route
      {
        path: "/deals/:id/edit",
        element: <DealsEdit />,
        auth: authRoles.admin,
      },
      // deal create route
      {
        path: "/deals/:stage/create",
        element: <DealsCreate />,
        auth: authRoles.admin,
      },
      // partners route
      { path: "/partners", element: <Partners />, auth: authRoles.admin },
      // partners route
      {
        path: "/partners/companies",
        element: <Companies />,
        auth: authRoles.admin,
      },
      // partner show route
      {
        path: "/partners/:id",
        element: <PartnerShow />,
        auth: authRoles.admin,
      },
      // partner edit route
      {
        path: "/partners/:id/edit",
        element: <PartnerEdit />,
        auth: authRoles.admin,
      },
      // leads route
      { path: "/leads", element: <Leads />, auth: authRoles.admin },
      // lead show route
      { path: "/leads/:id", element: <LeadShow />, auth: authRoles.admin },
      // lead edit route
      { path: "/leads/:id/edit", element: <LeadEdit />, auth: authRoles.admin },
      // usda route
      { path: "/usda", element: <Usda />, auth: authRoles.admin },
      // treasury route
      { path: "/treasury", element: <Treasury />, auth: authRoles.admin },
      // treasury uncoming payments list route
      {
        path: "/treasury/uncoming_payments",
        element: <UncomingPayments />,
        auth: authRoles.admin,
      },
      // treasury indicators route
      {
        path: "/treasury/indicators",
        element: <TreasuryIndicators />,
        auth: authRoles.admin,
      },
      // payment aproval route
      {
        path: "/treasury/payment_aproval/:paymentId",
        element: <PaymentAprovalForm />,
        auth: authRoles.admin,
      },
      // e-chart route
      {
        path: "/charts/echarts",
        element: <AppEchart />,
        auth: authRoles.editor,
      },
    ],
  },

  // session pages route
  { path: "/session/404", element: <NotFound /> },
  { path: "/session/signin", element: <JwtLogin /> },
  { path: "/session/signup", element: <JwtRegister /> },
  { path: "/session/forgot-password", element: <ForgotPassword /> },

  { path: "/", element: <Navigate to="dashboard/default" /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
